import { z } from 'zod';

import { businessVerificationStatusSchema } from './business';
import { postTypeSchema } from './post';

export const pulseSchema = z.object({
  good: z.number(),
  bad: z.number(),
  ideal: z.number(),
  total: z.number(),
});

export const profileStatsSchema = z.object({
  postCount: z.number(),
  upvotesReceived: z.number(),
  idealsProposed: z.number(),
  followerCount: z.number(),
  followingCount: z.number(),
  commentCount: z.number(),
});

export const publicProfileSchema = z.object({
  accountType: z.enum(['PERSONAL', 'BUSINESS']),
  /** Present on a business account — where the business itself lives. */
  business: z
    .object({
      slug: z.string(),
      name: z.string(),
      verificationStatus: businessVerificationStatusSchema,
    })
    .nullable(),
  id: z.string(),
  username: z.string(),
  displayName: z.string(),
  bio: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  homeTown: z.string(),
  homeCountryCode: z.string(),
  homeCountryName: z.string().nullable(),
  homeCountryFlag: z.string().nullable(),
  role: z.enum(['USER', 'MODERATOR', 'ADMIN']),
  createdAt: z.string(),
  stats: profileStatsSchema,
  pulse: pulseSchema,
  dominantType: postTypeSchema.nullable(),
  isFollowedByYou: z.boolean(),
  isBlockedByYou: z.boolean(),
  isYou: z.boolean(),
});

export const followResultSchema = z.object({
  isFollowing: z.boolean(),
  followerCount: z.number().optional(),
});

export const followingEntrySchema = z.object({
  id: z.string(),
  targetType: z.enum(['USER', 'COUNTRY', 'TOWN']),
  user: z
    .object({
      id: z.string(),
      username: z.string(),
      displayName: z.string(),
      avatarUrl: z.string().nullable(),
    })
    .nullable(),
  countryCode: z.string().nullable(),
  town: z.string().nullable(),
  createdAt: z.string(),
});

export const followingListSchema = z.array(followingEntrySchema);

export type PublicProfile = z.infer<typeof publicProfileSchema>;
export type Pulse = z.infer<typeof pulseSchema>;
export type FollowingEntry = z.infer<typeof followingEntrySchema>;
